import { formatNumber } from 'ui';

import type { Item } from '../../components/MaterialSampleBreakdown/MaterialSampleBreakdown';

export const formatSampleValue = (item: Item, precision?: number) => {
  if (item.unit === 'kilogram') {
    return formatNumber(Number(item.value), {
      maximumFractionDigits: precision,
      minimumFractionDigits: precision,
      style: 'kilogram',
    });
  }

  if (['text', ''].includes(item.unit)) {
    return item.value;
  }

  if (['percent', '%wm'].includes(item.unit)) {
    return `${item.value}${item.unit_display}`;
  }
  return `${item.value} ${item.unit_display}`;
};
